import { ShieldCheck, Mail } from 'lucide-react';
import { LegalLayout } from '../components/legal/LegalLayout';
import styles from './legal/Legal.module.css';

export function RefundPolicy() {
  return (
    <LegalLayout
      label="Refund Policy"
      title="Fair Refund Policy"
      subtitle="Transparent investigation for technical errors and duplicate payments."
      lastUpdated="May 14, 2026"
    >
      <h2>1. Digital Product Policy</h2>
      <p>PCCheckr sells one-time digital report credits. These credits are consumed upon the successful generation of a Full AI Diagnostic Report.</p>
      
      <h2>2. Eligibility for Refund</h2>
      <p>Refunds are eligible only under the following specific conditions:</p>
      <ul>
        <li>The refund request is made within 24 hours of the purchase timestamp.</li>
        <li>The purchased credits remain entirely unused in the user's account.</li>
        <li>A verified duplicate payment occurred for the same transaction.</li>
        <li>A confirmed technical error prevented the system from issuing credits after a successful payment.</li>
      </ul>

      <h2>3. Refund Request Requirements</h2>
      <p>To help us investigate refund requests fairly and efficiently, customers may be asked to provide:</p>
      <ul>
        <li>The email address used for the purchase.</li>
        <li>Stripe/payment receipt reference or transaction ID.</li>
        <li>A screenshot of any error message encountered.</li>
        <li>A short description of the technical issue experienced.</li>
        <li>The approximate date/time of the failed scan or report generation.</li>
      </ul>
      <p><strong>Note:</strong> We do not require users to share personal files, passwords, browser history, or private documents for refund investigations.</p>
      
      <h2>4. Technical Failure Guarantee</h2>
      <p>If the PCCheckr Scanner fails to run on your system, the .pcc diagnostic file cannot be generated, or the AI report cannot be generated due to a technical issue on our side, and the purchased credit remains unused, we will process a full refund after a brief review.</p>
      <p>If a report credit has already been used and a report was generated successfully, refunds are normally not available as the service has been rendered.</p>
      
      <h2>5. Refund Process</h2>
      <p>Approved refunds are processed back to the original payment method. Stripe and banking institutions typically take 3–5 business days to reflect the balance in your account.</p>
      
      <div className={styles.trustNotice}>
        <ShieldCheck className={styles.trustIcon} size={24} />
        <p>Our goal is fair support, not blocking genuine refunds. Refund requests are typically reviewed within 24 hours.</p>
      </div>

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <a 
          href="mailto:support@pccheckr.com?subject=Refund request — PCCheckr" 
          className="btn btn-primary"
          style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
        >
          <Mail size={18} /> Email support@pccheckr.com
        </a>
      </div>
    </LegalLayout>
  );
}
